import LibertyMoralityEmbed from "./images/LibertyMoralityEmbed";
import Ep0000ComingSoon from "./transcripts/Ep0000ComingSoon";
import Ep0001TruthLiberty from "./transcripts/Ep0001TruthLiberty";
import Ep0002Mission from "./transcripts/Ep0002Mission";
import Ep0003GodFirst from "./transcripts/Ep0003GodFirst";

const TranscriptsList = {
    tabHeading: 'TLN - Podcast Transcripts',
    metaDescription: `Transcripts for every episode of the True Liberty North Podcast.`,
    keywords: ["TrueLibertyNorth", "TrueLibertyNorth Podcast Transcripts", "True Liberty North Podcast Transcripts"],
    pageHeading: 'Transcripts',
    refresh: `Please REFRESH BROWSER for Updated List.`,
    image: LibertyMoralityEmbed,
    list: [
    Ep0001TruthLiberty,
    Ep0002Mission,
    Ep0003GodFirst,
    Ep0000ComingSoon,
    Ep0000ComingSoon,
    Ep0000ComingSoon,
    Ep0000ComingSoon,
    Ep0000ComingSoon,
    Ep0000ComingSoon,
    Ep0000ComingSoon,
    Ep0000ComingSoon,
    Ep0000ComingSoon
    ]
};

export default TranscriptsList;